import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useStore } from 'vuex'
import { getCommon } from '@/api/common'
import loadingPage from '@/components/loadingPage.vue'
import Cookies from 'js-cookie'
// import { useSelectUser } from "@/hooks/useSelectUser";

// useSelectUser()

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale('zh-cn')
const store = useStore()

store.dispatch('GET_BASE')

getCommon().then((res) => {
  Cookies.set('X-Access-Token', res.data.loginToken || '')
  // if(process.env.NODE_ENV === 'development') {
  //   Cookies.set("X-Access-Token",
  //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1bml0VHlwZSI6IjEiLCJ1bml0SWQiOiIxMDI3MjY1OTAwNDEzMTk0MjQyIiwidXNlclR5cGUiOiI2IiwiZXhwIjoxNzM3MjI1OTMyLCJ1c2VySWQiOiIxMjk3MTgxMTUwMzkxODMzNjAiLCJ0b2tlbk1hcmsiOiJkYTk5N2U0M2E1MGQ3NWUyZTc3ZmI3NmRmN2UyZmZlYSIsInVzZXJuYW1lIjoianhzbmNzcXNocV9hZG1pbiJ9.ORQPF8COdAyRkhczshsByrCFUyGAFj4iF6CNx2HboeA"
  //   );
  // }
  const { data } = res
  let emptyFavicon =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  let fav: any = document.querySelector('link[rel="icon"]')
  if (!fav) {
    fav = document.createElement('link')
    fav.rel = 'icon'
    document.head.appendChild(fav)
  }
  fav.href = data?.title || emptyFavicon
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      (_unref(store).state.loaded)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : (_openBlock(), _createBlock(loadingPage, { key: 1 }))
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})